import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container, Box, Typography, Button, CircularProgress, Alert,
} from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import ScoutCard from '../../components/scout/ScoutCard';
import { scoutService } from '../../services/scoutService';

const ScoutInboxPage: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [threads, setThreads] = useState<any[]>([]);

  useEffect(() => {
    scoutService.list('athlete')
      .then(setThreads)
      .catch((err) => setError(err.response?.data?.message || 'スカウト一覧の取得に失敗しました'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f5f5f5' }}>
      <Box sx={{ bgcolor: '#0066cc', color: 'white', py: 3 }}>
        <Container maxWidth="md">
          <Button startIcon={<ArrowBack />} onClick={() => navigate('/athlete/dashboard')}
            sx={{ color: 'white', mb: 1 }}>
            ダッシュボード
          </Button>
          <Typography variant="h4" sx={{ fontWeight: 600, fontSize: { xs: '1.5rem', md: '2rem' } }}>
            スカウト受信箱
          </Typography>
          <Typography variant="body2" sx={{ mt: 0.5, opacity: 0.9 }}>
            {threads.length}件のスカウト
          </Typography>
        </Container>
      </Box>

      <Container maxWidth="md" sx={{ py: 4 }}>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

        {loading ? (
          <Box sx={{ textAlign: 'center', py: 4 }}><CircularProgress /></Box>
        ) : threads.length === 0 ? (
          <Box sx={{ textAlign: 'center', py: 8 }}>
            <Typography variant="h6" sx={{ color: '#666', mb: 2 }}>
              まだスカウトはありません
            </Typography>
            <Typography variant="body2" sx={{ color: '#999' }}>
              プロフィールを匿名公開すると、企業からスカウトを受け取れるようになります
            </Typography>
          </Box>
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {threads.map((thread) => (
              <ScoutCard
                key={thread.threadId}
                thread={thread}
                role="athlete"
                onClick={() => navigate(`/athlete/scouts/${thread.threadId}`)}
              />
            ))}
          </Box>
        )}
      </Container>
    </Box>
  );
};

export default ScoutInboxPage;
